"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortSurveysList = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _uuid = _interopRequireDefault(require("uuid"));
var _reactBootstrap = require("react-bootstrap");
var _sortUtil = _interopRequireDefault(require("../sortUtil"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _constants = _interopRequireDefault(require("./constants"));
var sortSurveysList = function sortSurveysList(a, b, order) {
  var firstValue = _lodash.default.filter(a.programDetails, function (i) {
    return i.formStatus !== null && i.containerName === _constants.default.CONTAINER_NAME.SURVEYS;
  }) || [];
  var secondValue = _lodash.default.filter(b.programDetails, function (i) {
    return i.formStatus !== null && i.containerName === _constants.default.CONTAINER_NAME.SURVEYS;
  }) || [];
  return _sortUtil.default.compareNumber(firstValue.length, secondValue.length, order);
};

/**
 * Render survey list
 * @param  {Object} data
 * @return {Element} React element
 */
exports.sortSurveysList = sortSurveysList;
var SurveysList = function SurveysList(props) {
  var data = props.data,
    t = props.t;
  if (data.participantId === null || !data.platformParticipantId) {
    return /*#__PURE__*/_react.default.createElement("div", null, "N/A");
  }
  var complete = [];
  var paused = [];
  var notEligible = [];
  var notStarted = [];
  var notReady = [];
  var programDetails = data.programDetails;
  programDetails = programDetails.filter(function (s) {
    return s.containerName === _constants.default.CONTAINER_NAME.SURVEYS;
  });
  programDetails = _lodash.default.sortBy(programDetails, 'displayOrder');
  _lodash.default.forEach(programDetails, function (s) {
    if (s.formStatus === _constants.default.FORM_STATUS.COMPLETED) {
      complete.push(s);
    } else if (s.formStatus === _constants.default.FORM_STATUS.PAUSED) {
      paused.push(s);
    } else if (s.formStatus === _constants.default.FORM_STATUS.NOT_ELIGIBLE) {
      notEligible.push(s);
    } else if (s.formStatus === _constants.default.FORM_STATUS.NOT_STARTED) {
      notStarted.push(s);
    } else if (s.formStatus === _constants.default.FORM_STATUS.NOT_READY) {
      notReady.push(s);
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: _styles.default['survey-tooltip-container']
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "left",
    overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
      className: _styles.default['survey-tooltip']
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "survey-title"
    }, t('Not Eligible/Not Ready:')), /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(notEligible, function (survey) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "not-eligible-".concat(_uuid.default.v4())
      }, " ", t(survey.formDisplayName));
    }), _lodash.default.map(notReady, function (survey) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "not-ready-".concat(_uuid.default.v4())
      }, " ", t(survey.formDisplayName));
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "survey-title"
    }, t('Not Started:')), /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(notStarted, function (survey) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "not-started-".concat(_uuid.default.v4())
      }, " ", t(survey.formDisplayName));
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "survey-title"
    }, t('Paused:')), /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(paused, function (survey) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "not-completed-".concat(_uuid.default.v4())
      }, t(survey.formDisplayName));
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "survey-title"
    }, t('Completed:')), /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(complete, function (survey) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "completed-".concat(_uuid.default.v4())
      }, " ", t(survey.formDisplayName));
    })))
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    className: "survey-tooltip-cell"
  }, /*#__PURE__*/_react.default.createElement("div", null, "(", notEligible.length + notReady.length, ") ", t('Not Eligible/Not Ready')), /*#__PURE__*/_react.default.createElement("div", null, "(", notStarted.length, ") ", t('Not Started')), /*#__PURE__*/_react.default.createElement("div", null, "(", paused.length, ") ", t('Paused')), /*#__PURE__*/_react.default.createElement("div", null, "(", complete.length, ") ", t('Completed')))));
};
SurveysList.propTypes = {
  data: _propTypes.default.shape({
    participantId: _propTypes.default.number,
    platformParticipantId: _propTypes.default.number,
    programDetails: _propTypes.default.shape({
      filter: _propTypes.default.func
    })
  }).isRequired,
  t: _propTypes.default.func
};
SurveysList.defaultProps = {
  t: function t(x) {
    return x;
  }
};
var _default = SurveysList;
exports.default = _default;